import "./payrollSettings.css";
import "../../companyDetails.css";
import T from "utils/constants/T";
import { get, noop } from "lodash";
import {
  StyledBodyTypography,
  StyledTitleTypography,
} from "../CompanyTab/CompanyInfo";

import { useNavigate } from "react-router";
import MainCard from "components/MainCard";
import { Button, Grid } from "@mui/material";
import CashDCard from "components/common/CashDCard";

interface ViewPayrollSettingsProps {
  cashDCapitalCategory: any;
  cashDCapitalFeeCategory: any;
  companyName: string;
  systemName: string;
  role: string;
  handleSync: any;
}
const ViewPayrollSettings = ({
  cashDCapitalCategory = {},
  cashDCapitalFeeCategory = {},
  companyName = "",
  systemName = "",
  role = "",
  handleSync = noop,
}: ViewPayrollSettingsProps) => {
  const navigate = useNavigate();
  const handleEdit = () => {
    navigate("/companyDetails/payrollSettings/edit");
  };

  return (
    <MainCard
      title={systemName}
      secondary={
        <>
          <Button
            variant="outlined"
            className="main-card-button"
            onClick={handleSync}
            // startIcon={<CachedIcon />}
          >
            {T.SYNC_PAYROLL}
          </Button>
          &nbsp;&nbsp;&nbsp;
          {(role === "superadmin" || role === "employer")&& (
            <Button
              variant="contained"
              className="main-card-button"
              onClick={handleEdit}
            >
              {T.EDIT}
            </Button>
          )}
        </>
      }
    >
      <StyledBodyTypography>
        {T.DEDUCTION_FILE_CATEGORY_SELECTION}
      </StyledBodyTypography>
      <CashDCard borderRadius="20px">
        <Grid container>
          <Grid item xs={6}>
            <StyledTitleTypography>{T.CASH_D_CAPITAL}</StyledTitleTypography>
            <StyledBodyTypography>
              {get(cashDCapitalCategory, "name", "")}
            </StyledBodyTypography>
          </Grid>
          <Grid item xs={6}>
            <StyledTitleTypography>{T.CASH_D_FEE}</StyledTitleTypography>
            <StyledBodyTypography>
              {get(cashDCapitalFeeCategory, "name", "")}
            </StyledBodyTypography>
          </Grid>
        </Grid>
      </CashDCard>
    </MainCard>
  );
};

export default ViewPayrollSettings;
